import { t } from 'i18next'

import bubbleChartstyles from 'components/Shared/Charts/ChartTooltip/ChartTooltip.module.scss'
import { formatNumbers } from 'lib/Helper'

const popupForCluster = (feature: any) => {
  const clusterCount = feature.graphic.attributes.cluster_count
  const contributionSum = feature.graphic.attributes.contribution_sum
  const contributorSum = feature.graphic.attributes.contributor_sum

  const formattedLocations = t(
    `reporting.overview.location${clusterCount === 1 ? 'One' : 'Other'}`,
  )
  const formattedContributors = t(
    `reporting.overview.contributor${contributorSum === 1 ? 'One' : 'Other'}`,
  )
  const formattedContribution = t(
    `reporting.overview.contribution${contributionSum === 1 ? 'One' : 'Other'}`,
  )

  return `<div class="${bubbleChartstyles.flexContainer}">
       <div class="${bubbleChartstyles.tooltipSize}">
        ${formatNumbers(contributionSum)} ${formattedContribution} 
        ${t('common.from')} 
        ${formatNumbers(contributorSum)} ${formattedContributors}
        ${t('common.in')} 
        ${formatNumbers(clusterCount)} ${formattedLocations}
       </div>
    </div>`
}

const popupForSingleFeature = (feature: any) => {
  const contributionSum = feature.graphic.attributes.contributions
  const contributors = feature.graphic.attributes.contributors
  const locationName = feature.graphic.attributes.name

  const formattedContributors = t(
    `reporting.overview.contributor${contributors === 1 ? 'One' : 'Other'}`,
  )
  const formattedContribution = t(
    `reporting.overview.contribution${contributionSum === 1 ? 'One' : 'Other'}`,
  )

  return `<div class="${bubbleChartstyles.flexContainer}">
       <div class="${bubbleChartstyles.tooltipSize}">
        ${formatNumbers(contributionSum)} ${formattedContribution} 
        ${t('common.from')} 
        ${formatNumbers(contributors)} ${formattedContributors}
        ${t('common.in')} 
        ${locationName}
       </div>
    </div>`
}

// Popup / Hover template
const populateHoverBox = (feature: any) => {
  return feature.graphic.isAggregate
    ? popupForCluster(feature)
    : popupForSingleFeature(feature)
}

// Popup / Hover template
export const popupTemplate = (t: any) => {
  return {
    title: t('reporting.overview.contributionsLocation'),
    content: populateHoverBox,
    outFields: ['*'],
  }
}
